import * as configUtil from '@/config'

const ABIData = configUtil.getCurrentContractConfig()

export default ABIData


